export enum InvoiceItemType {
  MONTHLY_USER_FEE = 'MONTHLY_USER_FEE',
  ISSUED_CARD_FEE = 'ISSUED_CARD_FEE',
  RENEW_CARD_FEE = 'RENEW_CARD_FEE',
  EMPLOYEE_SPEND = 'EMPLOYEE_SPEND',
}

